// extracted by mini-css-extract-plugin
module.exports = {"onboardingTabs":"onboarding-tabs_onboardingTabs__8L6dZ","tabs":"onboarding-tabs_tabs__lAdtR","loaderContainer":"onboarding-tabs_loaderContainer__RA_rU"};